var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconHistory = function SvgIconHistory(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-496 -16) translate(265 -42) translate(231 58) translate(4 4)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#343434",
    stroke: "#343434",
    strokeWidth: 2.1
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.397 0C7.1 0 7.676.535 7.741 1.22l.006.13v6.531c0 .746-.604 1.35-1.35 1.35-.701 0-2.278-.535-2.344-1.22l-.006-.13 1-6.531c0-.746.605-1.35 1.35-1.35z",
    opacity: 0.77,
    transform: "translate(4.251 3.36)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.077 5.65c.233-.658.925-1.024 1.59-.862l.133.039 5.047.781c.703.248 1.071 2.02.823 2.723-.232.659-.925 1.024-1.59.863l-.132-.04L.9 7.373C.198 7.125-.17 6.353.077 5.651z",
    transform: "translate(4.251 3.36)"
  })))))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconHistory);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "icon-history.1e8be52a5e41406ff456c92df1cb6f28.svg";